import { Box, useColorModeValue, Stack } from "@chakra-ui/react"
import Link from "next/link"
import { useAccent8 } from "src/modeAwareColors"
import { useState } from "react"
import { capitalizeEach } from "src/util"
import NextImage from "./NextImage"
import { H5 } from 'src/typography/typography'

function TaxonomyCard({
	src,
	href,
	title,
	...rest }) {
	const [isHovering, setIsHovering] = useState(false)
	const borderWidth = useColorModeValue('0', '1px')

	return (
		<Link href={href} passHref>
			<Stack
				direction='row'
				cursor='pointer'
				alignItems='center'
				spacing='sm'
				pr='sm'
				borderRadius='md'
				transition='box-shadow .15s'
				onMouseEnter={() => setIsHovering(true)}
				onMouseLeave={() => setIsHovering(false)}
				borderWidth={borderWidth}
				_hover={{
					transiton: 'box-shadow .15s',
					boxShadow: 'md',
					borderColor: useAccent8(),
				}}
				{...rest}
			>
				<Box
					flexShrink={0}
					marginBottom='-6px' // for some dumbass reason next/image puts an inline-block div around the image
				>
					<NextImage
						dimensions={[80, 80]}
						borderRadius='md'
						borderTopRightRadius={isHovering ? 0 : 'md'}
						borderBottomRightRadius={isHovering ? 0 : 'md'}
						transition='border-radius .15s'
						layout='fixed'
						src={src}
					/>
				</Box>
				<H5
					as='h2'
					flexShrink={1}
				>
					{capitalizeEach(title)}
				</H5>
			</Stack>
		</Link>
	)
}

export default TaxonomyCard
